import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useAppSelector } from '../../../../../app/store';
import reducerPath from '../../../../../app/reducerPath';
import Container from './styles/Container';
import NumLabel from './styles/NumLabel';

function WarehouseActiveRegNums({ vehicleIds }) {
  const {
    data: { source },
    stateData,
  } = useAppSelector((state) => state[`${reducerPath.logisticTasksBalanceResource}/counter`]);

  const vehicleStates = stateData?.stateMap?.vehicleStates;
  const vehicles = source?.truckDetailsList;

  const currentVehicles = useMemo(() => {
    if (!vehicles?.length || !vehicleIds?.length) return [];

    return vehicles
      .filter((v) => vehicleIds.includes(v.vehicleId))
      .map((v) => ({
        id: v.vehicleId,
        regNum: v.regNum,
        status: vehicleStates?.[v.vehicleId]?.status ?? null,
      }))
      .filter((v) => v.status === 'QUEUE' || v.status === 'UNLOADING');
  }, [vehicles, vehicleIds, vehicleStates]);

  return (
    <Container>
      {currentVehicles.map((vehicle) => (
        <NumLabel
          key={vehicle.id}
          title={vehicle.status === 'QUEUE' ? 'В очереди' : 'Разгружается'}
          isQueue={vehicle.status === 'QUEUE'}
        >
          {vehicle.regNum}
        </NumLabel>
      ))}
    </Container>
  );
}

WarehouseActiveRegNums.propTypes = {
  vehicleIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default WarehouseActiveRegNums;
